import { useDocumentTitle } from "@uidotdev/usehooks";
import StyledLink from "../../components/Link";
import { PrimaryButton } from "../../ui/Buttons";
import { Card } from "../../ui/Card";

export const Aersage = () => {
    useDocumentTitle("AERSAGE - AERSHED");

    return (
        <div className="prose px-6 max-w-6xl mx-auto">
            <h1 className="flex pt-10 font-bold font-sans antialiased text-inherit text-xl">
                AERSAGE - AI regulatory helper from Aerscape
            </h1>

            <Card>
                <div className="text-base">
                    <p>
                        AERSAGE is Aerscape’s AI-powered regulatory assistant,
                        designed to assist and research inside OOOO regulations.
                    </p>

                    <div>
                        <PrimaryButton
                            onClick={() =>
                                open("https://aersage.aerscape.com", "_blank")
                            }
                        >
                            Launch AERSAGE
                        </PrimaryButton>
                    </div>

                    <div className="">
                        <h2 className="text-lg font-semibold">
                            Getting Started
                        </h2>
                        <ol className="list-decimal">
                            <li>
                                <strong>Request an account:</strong> Submit an
                                access request below.
                                <StyledLink
                                    to="https://aersage.aerscape.com/accounts/request-account/"
                                    openOnNewTab
                                >
                                    Request account.
                                </StyledLink>
                            </li>
                            <li>
                                Aerscape staff will reach out with instructions
                                on how to access the platform and reset your
                                password.
                            </li>
                            <li>
                                <strong>Log in and ask questions:</strong> e.g.,{" "}
                                <em>
                                    “What are the Leak Detection and Repair
                                    requirements for Compressor Stations built
                                    in January of 2024?”
                                </em>
                            </li>
                            <li>
                                <strong>Review results:</strong> Aerregs will
                                return a structured answer, with direct
                                references to the original regulatory text.
                            </li>
                        </ol>
                    </div>
                </div>
            </Card>
        </div>
    );
};
